import { Transition, motion } from 'framer-motion'
import { Logo, Spinner, View } from './styled'
import { useAppContext } from 'context/app-context'

const transition: Transition = {
  type: 'tween',
  ease: 'easeIn',
  duration: 0.4,
}

export const Loader = () => {
  const { logoUrl } = useAppContext()

  return (
    <View exit={{ opacity: 0, transition: { delay: 0.5, ...transition } }}>
      <motion.div exit={{ opacity: 0, translateY: '-1rem', transition }}>
        <Logo src={logoUrl} />
      </motion.div>
      <Spinner
        exit={{
          opacity: 0,
          translateY: '-1rem',
          transition: { delay: 0.2, ...transition },
        }}
      />
    </View>
  )
}
